import type { SyncTarget } from "@/data/models/Client";

/**
 * Whether a client is linked to at least one external system (`syncProjectsWith.erpSystems`). While it
 * is, IRES Office leaves Projektnummer Office and Sammelnummer to that system and offers the API settings.
 *
 * An empty list is no link: unlinking the last system leaves `[]` behind, and IRES Cloud reads it the
 * same way (`erpSystems.length > 0`). Pure.
 */
export function hasErpSystemLink(syncProjectsWith: SyncTarget | null | undefined): boolean {
  return (syncProjectsWith?.erpSystems?.length ?? 0) > 0;
}
